import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import styles from './DialogFinalizeSKP.module.css'

import ImgClipBoardSchoolList from 'assets/icons/img-clip-board-school-list.svg'

interface DialogFinalizeSKPProps extends Omit<DialogProps, 'children'> {
  isFinalizing?: boolean
  onClickFinalize?: () => any
  onClickCancel?: () => any
  satuanPendidikan: string
}

const DialogFinalizeSKP = ({
  isFinalizing,
  onClickFinalize = () => {},
  onClickCancel = () => {},
  satuanPendidikan,
  ...props
}: DialogFinalizeSKPProps) => {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent className={styles.wiggle}>
        <DialogCloseButton data-testid="btn-close" />
        <div className="mt-12 p-6">
          <ImgClipBoardSchoolList width={84} height={84} />
          <Text variant="display-sm" className="mt-4">
            Ajukan Perencanaan Kinerja ke atasan?
          </Text>
          <Text color="subdued" className="mt-4 !text-xl">
            Atasan akan lanjut memeriksa. Mohon diskusi dengan atasan terlebih
            dahulu atau simpan draf jika diperlukan.
          </Text>

          <span className="mt-4 p-4 rounded border border-gray-30 bg-gray-5 flex gap-[85px]">
            <Text variant="body-sm" color="subdued">
              Ajukan ke atasan di:
            </Text>
            <Text variant="body-sm">{satuanPendidikan}</Text>
          </span>

          <div className="flex gap-5 mt-5">
            <Button
              size="lg"
              className="w-[190px]"
              disabled={isFinalizing}
              isLoading={isFinalizing}
              onClick={() => onClickFinalize()}
              data-testid="btn-confirm"
            >
              Ajukan
            </Button>
            <Button
              size="lg"
              color="white"
              disabled={isFinalizing}
              isLoading={isFinalizing}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
            >
              Simpan draf
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogFinalizeSKP
